import { useState, useEffect } from "react"
import HCRender from "../hc-render"

const HomeLayout = ({
  isHomePage,
  breadcrumbs = [],
  refreshKey,
  currentLanguage,
  searchState,
  onSearchResultSelect,
  rootCategoriesData,
  onArticleSelect,
  onCategorySelect,
  expandedCategories,
  currentPath,
  isLoading,
  error,
  selectedContent,
  contentType,
  onFeedback,
  navigateTo,
}) => {
  const Header = HCRender.getFragment("Header")
  const BreadcrumbsSection = HCRender.getFragment("BreadcrumbsSection")
  const HomePage = HCRender.getFragment("HomePage")
  const ContentPage = HCRender.getFragment("ContentPage")

  const [isClient, setIsClient] = useState(false)
  useEffect(() => { setIsClient(true) }, [])

  const shouldShowBreadcrumbs = isClient && !isHomePage && breadcrumbs.length > 0

  return (
    <div
      className="relative overflow-x-clip bg-canvas min-h-screen"
      key={`help-center-${refreshKey}-${currentLanguage}`}
    >
      <section className="relative -mt-16 pt-20 md:pt-24 pb-20 md:pb-32 px-4 md:px-8 overflow-hidden">
        {/* Same hero gradient as Features. */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-canvas to-secondary/15 pointer-events-none" />

        <div className="relative z-10 w-full flex flex-col">
          {Header && (
            <Header
              searchState={searchState}
              onSearchResultSelect={onSearchResultSelect}
            />
          )}

          {shouldShowBreadcrumbs && BreadcrumbsSection && (
            <BreadcrumbsSection items={breadcrumbs} />
          )}

          <div className="w-full max-w-w2_xl flex-grow flex mx-auto">
            {isHomePage ? (
              HomePage && <HomePage />
            ) : (
              ContentPage && (
                <ContentPage
                  rootCategoriesData={rootCategoriesData}
                  onArticleSelect={onArticleSelect}
                  onCategorySelect={onCategorySelect}
                  expandedCategories={expandedCategories}
                  currentPath={currentPath}
                  isLoading={isLoading}
                  error={error}
                  selectedContent={selectedContent}
                  contentType={contentType}
                  onFeedback={onFeedback}
                  navigateTo={navigateTo}
                />
              )
            )}
          </div>
        </div>
      </section>
    </div>
  )
}

export default HomeLayout
